angular.module('unica_hospitality.hospitality_controllers')

.controller('HospitalityDashboardController', function() {

});